import { clampStars } from './reviewsFormat'

export type StarRatingProps = {
  /** Raw rating; rounded + clamped to 0..5 for display. */
  rating: number
  /** Sizing/extra classes for the wrapping element (e.g. 'text-xl', 'text-base'). */
  className?: string
}

/**
 * Five-star rating. One readable label on the wrapper (`role="img"`); the
 * glyphs are decorative (`aria-hidden`) so screen readers announce
 * "N of 5 stars" once instead of reading ten star characters. Filled stars
 * use the `--color-star` token; empty stars are gray-300.
 */
export function StarRating({ rating, className }: StarRatingProps) {
  const n = clampStars(rating)
  return (
    <span role="img" aria-label={`${n} of 5 stars`} className={`inline-block leading-none ${className ?? ''}`}>
      <span aria-hidden="true" style={{ color: 'var(--color-star, #fbbc05)' }}>
        {'★'.repeat(n)}
      </span>
      <span aria-hidden="true" className="text-gray-300">
        {'★'.repeat(5 - n)}
      </span>
    </span>
  )
}
